/* eslint-disable */
import React, { useState } from "react";
import PropTypes from "prop-types";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { fade, makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import A_IconButton from "../../../Atoms/Inputs/Buttons/A_IconButton";
import A_AppBar from "../../../Atoms/Surfaces/Appbars/A_AppBar";
import ClientLogoSvg from "./ClientLogoSvg";
import M_UserArea from "./M_UserArea";
import M_AddEntity from "./AddEntity/M_AddEntity";
import { useMediaQuery } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentEventValue } from "../../../../../store/actions/getEventValueAction";
import A_SimpleDialog from "../../../Atoms/Feedback/Dialogs/A_SimpleDialog";
import A_Button from "../../../Atoms/Inputs/Buttons/A_Button";
import {
  excludedClientsForAddEntity,
  isClientAuthorised,
} from "./M_NavBarhelper";
import { Logos } from "../../../Pages/Common/User Management/HelperFunctions";

const useStyles = makeStyles((theme) => ({
  "@keyframes navBackgroundShift": {
    "0%": {
      transform: "translate3d(-16%, -4%, 0) scale(1)",
    },
    "50%": {
      transform: "translate3d(18%, 8%, 0) scale(1.08)",
    },
    "100%": {
      transform: "translate3d(-16%, -4%, 0) scale(1)",
    },
  },
  "@keyframes navGlowFloat": {
    "0%": {
      transform: "translate3d(0, 0, 0) scale(1)",
      opacity: 0.32,
    },
    "50%": {
      transform: "translate3d(-14%, 16%, 0) scale(1.18)",
      opacity: 0.48,
    },
    "100%": {
      transform: "translate3d(0, 0, 0) scale(1)",
      opacity: 0.32,
    },
  },
  "@keyframes navGridDrift": {
    "0%": { transform: "translate3d(0, 0, 0)" },
    "100%": { transform: "translate3d(0, 0, 0)" },
  },
  "@keyframes navDataPulse": {
    "0%": { opacity: 0.18, transform: "scaleY(0.82)" },
    "50%": { opacity: 0.42, transform: "scaleY(1.08)" },
    "100%": { opacity: 0.18, transform: "scaleY(0.82)" },
  },
  "@keyframes navSignalSweep": {
    "0%": { transform: "translate3d(0,0,0)", opacity: 0 },
    "100%": { transform: "translate3d(0,0,0)", opacity: 0 },
  },
  wrapperDiv: {
    [theme.breakpoints.down("sm")]: {
      position: "relative",
    },
  },
  wrapperDivToggle: {
    [theme.breakpoints.down("xs")]: {
      minWidth: "97vw",
      position: "fixed",
      zIndex: "89",
      paddingTop: "1.2em",
      paddingBottom: "1.2em",
      marginLeft: "-60vw",
      backgroundColor: "var(--header-background)",
      borderRadius: "5px",
      height: 43,
      display: "flex",
      alignItems: "center",
    },
  },

  closeIconOnMobile: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      marginLeft: "87vw !important",
      "&:focus": {
        fontSize: "32px",
      },
      "&:hover": {
        transform: "rotate(180deg)",
      },
    },
  },

  root: {
    flexGrow: 1,
  },
  appBar: {
    color: "var(--color-primary-contrast)",
    // real frosted glass: themed tint at ~66% over a heavy blur of the page
    // behind it. Falls back to A_AppBar's solid --header-background where
    // color-mix() is unsupported (the !important declaration just gets dropped).
    backgroundColor:
      "color-mix(in srgb, var(--header-background) 66%, transparent) !important",
    // glass-pane sheen: bright top edge fading to a faint bottom shade
    backgroundImage:
      "linear-gradient(180deg, rgba(255,255,255,0.24) 0%, rgba(255,255,255,0.07) 40%, rgba(255,255,255,0) 62%, rgba(0,0,0,0.1) 100%)",
    boxShadow:
      "0 14px 40px rgba(15, 23, 42, 0.32), inset 0 1px 0 rgba(255,255,255,0.3), inset 0 0 0 1px rgba(255,255,255,0.06)",
    borderBottom: "1px solid rgba(255,255,255,0.16)",
    backdropFilter: "blur(24px) saturate(185%)",
    WebkitBackdropFilter: "blur(24px) saturate(185%)",
    transition: "background-color 0.4s ease",
  },
  toolbar: {
    backgroundColor: "transparent",
    color: "var(--color-primary-contrast)",
    objectFit: "contain",
    overflow: "hidden",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    minHeight: 54,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    boxSizing: "border-box",
    position: "relative",
    backdropFilter: "blur(14px) saturate(135%)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,0.18), inset 0 -1px 0 rgba(0,0,0,0.14)",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      background:
        "linear-gradient(105deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0) 32%, rgba(255,255,255,0) 70%, rgba(255,255,255,0.05) 100%)",
      opacity: 0.8,
      pointerEvents: "none",
    },
    // soft theme-tinted glow hugging the logo side — picks up --color-primary-main
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      background:
        "radial-gradient(60% 180% at 6% 50%, var(--color-primary-main), transparent 42%)",
      opacity: 0.18,
      pointerEvents: "none",
    },
    "& $toolbarAnalytics": {
      position: "absolute",
      inset: 0,
      pointerEvents: "none",
      overflow: "hidden",
      opacity: 0.9,
    },
    "& > *": {
      position: "relative",
      zIndex: 1,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minHeight: 50,
      paddingLeft: theme.spacing(1.25),
      paddingRight: theme.spacing(1.25),
    },
  },
  toolbarLeft: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    gap: theme.spacing(1),
  },
  toolbarRight: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    marginLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(0.75),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(1),
      gap: theme.spacing(0.5),
      paddingRight: theme.spacing(0.25),
    },
  },
  ToolbarColor: {
    color: "var(--color-primary-contrast)",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      marginTop: "-0.2em",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
  menuButton: {
    padding: "8px !important",
    color: "var(--color-primary-contrast)",
    borderRadius: 10,
    transition: "background-color 0.2s ease, transform 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.14)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
    },
  },
  title: {
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  mnavSearch: {
    "&&": {
      position: "relative",
      borderRadius: 999,
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0.07) 100%)",
      border: "1px solid rgba(255,255,255,0.22)",
      boxShadow:
        "inset 0 1px 0 rgba(255,255,255,0.16), 0 8px 22px rgba(15, 23, 42, 0.12)",
      backdropFilter: "blur(16px) saturate(160%)",
      WebkitBackdropFilter: "blur(16px) saturate(160%)",
      transition:
        "background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease",
      marginLeft: 0,
      marginRight: 10,
      width: "30%",
      maxWidth: 360,
    },
    "&&:hover": {
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0.11) 100%)",
      borderColor: "rgba(255,255,255,0.32)",
    },
    "&&:focus-within": {
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0.15) 100%)",
      borderColor: "rgba(255,255,255,0.45)",
      boxShadow:
        "inset 0 1px 0 rgba(255,255,255,0.2), 0 10px 26px rgba(15, 23, 42, 0.18)",
    },
    [theme.breakpoints.down("sm")]: {
      "&&": {
        width: "12ch",
        minWidth: 104,
      },
    },
    [theme.breakpoints.up("md")]: {
      "&&": {
        marginLeft: theme.spacing(1),
        width: "auto",
      },
    },
  },

  mnavSearchIcon: {
    "&&": {
      padding: theme.spacing(0, 2),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "rgba(255,255,255,0.72)",
    },
    [theme.breakpoints.down("sm")]: {
      "&&": {
        marginLeft: "-5px",
      },
    },
  },
  mnavInputRoot: {
    "&&": {
      color: "var(--color-primary-contrast)",
      font: "inherit",
      cursor: "text",
      display: "inline-flex",
      position: "relative",
      alignItems: "center",
      boxSizing: "border-box",
      lineHeight: "1.1876em",
    },
    'html[data-mode="dark"] &&': {
      color: "var(--color-primary-contrast)",
    },
    [theme.breakpoints.down("sm")]: {
      "&&": {
        width: "100px",
      },
    },
  },
  mnavInputRootToggle: {
    "&&": {
      color: "var(--color-primary-contrast)",
      font: "inherit",
      cursor: "text",
      display: "inline-flex",
      position: "relative",
      alignItems: "center",
      boxSizing: "border-box",
      lineHeight: "1.1876em",
    },
    'html[data-mode="dark"] &&': {
      color: "var(--color-primary-contrast)",
    },
    [theme.breakpoints.down("sm")]: {
      "&&": {
        width: "85vw",
      },
    },
  },
  mnavInputInput: {
    "&&": {
      font: "inherit",
      letterSpacing: "inherit",
      border: 0,
      background: "none",
      boxSizing: "content-box",
      height: "1.1876em",
      margin: 0,
      display: "block",
      minWidth: 0,
      WebkitTapHighlightColor: "transparent",
      padding: theme.spacing(0.7, 1, 0.7, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create("width"),
      color: "var(--color-primary-contrast)",
      width: "100%",
    },
    'html[data-mode="dark"] &&': {
      color: "var(--color-primary-contrast)",
    },
    'html[data-mode="dark"] &&::placeholder': {
      color: "rgba(255,255,255,0.72)",
      opacity: 1,
    },
    "&&:focus": {
      outline: 0,
    },
    "&&::placeholder": {
      color: "rgba(255,255,255,0.72)",
      opacity: 1,
    },
    [theme.breakpoints.up("sm")]: {
      "&&": {
        width: "12ch",
      },
      "&&:focus": {
        width: "20ch",
      },
    },
    [theme.breakpoints.down("xs")]: {
      "&&": {
        marginLeft: "-3px",
        fontSize: "13px",
        width: "5.5ch",
      },
      "&&:focus": {
        width: "100ch",
      },
    },
  },
  hideSearch: {
    display: "none",
  },

  person: {
    marginRight: "11%",
    width: "0px",
    height: "0px",
    marginTop: "-3%",
  },
  logo: {
    filter: "drop-shadow(0 3px 10px rgba(0,0,0,0.16))",
    display: "block",
    height: "auto",
    flexShrink: 0,
  },
  toolbarAnalytics: {},
}));
const BeforeLogin = (props) => {
  const classes = { props };
  return (
    <React.Fragment>
      <Typography variant="h6" className={classes.title}>
        Equipped Cloud
      </Typography>
    </React.Fragment>
  );
};

const AfterLogin = (props) => {
  let history = useHistory();
  const isMobile = useMediaQuery("(max-width:600px)");
  const currentURL = window.location.href;
  const lastWord = currentURL.split("/").pop();
  const classes = useStyles();
  const isSearchShow = useSelector((state) => state.showSearch);
  const currentPage = useSelector((state) => state.currentPage);
  const showEntity = isClientAuthorised(
    window.location.hostname,
    excludedClientsForAddEntity
  );
  const [defValue, setDefValue] = useState("");
  const [InitialBooleanValue, setInitialBooleanValue] = useState(true);
  const toggleBooleanValue = () => {
    setInitialBooleanValue(false);
  };
  const toggleBooleanValueAgain = () => {
    setInitialBooleanValue(true);
  };

  const [isMsgOpen, setIsMsgOpen] = useState(false);
  const eventValue = useSelector((state) => state.getEventValueStore);
  const dispatch = useDispatch();
  React.useLayoutEffect(() => {
    setDefValue("");
  }, [currentPage && currentPage.data]);

  const LogoRedirection = () => {
    if (!currentPage.isLoading) {
      history.push(localStorage.UserDefaultURL);
      window.location.reload();
    }
  };
  let handleCancelPopup = () => {
    setIsMsgOpen(false);
  };
  let handleLeavePopup = () => {
    setIsMsgOpen(false);
    props.handleDrawer(true);
    dispatch(getCurrentEventValue(false));
  };
  let handleMsgPopup = () => {
    setIsMsgOpen(false);
  };

  const getPublishActionItems = () => {
    return (
      <>
        <A_Button
          color="primary"
          label="Leave"
          autoFocus
          onClick={handleLeavePopup}
        />
        <A_Button color="default" label="Cancel" onClick={handleCancelPopup} />
      </>
    );
  };
  const handleMenuButtonClick = (e) => {
    if (eventValue) {
      setIsMsgOpen(true);
      return;
    }
    props.handleDrawer(true);
  };
  return (
    <>
      <Toolbar className={classes.toolbar}>
        <div className={classes.toolbarAnalytics} />
        <div className={classes.toolbarLeft}>
          <A_IconButton
            aria-label="menu"
            size="medium"
            icon={<FontAwesomeIcon icon={faBars} style={{ fontSize: "17px", color: "var(--color-primary-contrast)" }} />}
            className={classes.menuButton}
            onClick={handleMenuButtonClick}
          />
          <ClientLogoSvg
            className={classes.logo}
            style={{
              cursor: currentPage.isLoading ? "default" : "pointer",
            }}
            width={isMobile ? 84 : 110}
            onClick={(e) => LogoRedirection(e)}
          />
        </div>
        {lastWord !== "securelogout" ? (
          <div className={classes.toolbarRight}>
            <div>
              <div
                className={
                  isSearchShow === true
                    ? classes.mnavSearch
                    : classes.hideSearch
                }
              >
                <div className={classes.mnavSearchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  value={defValue}
                  id="globalsearch"
                  placeholder="Search"
                  onChange={(e) => {
                    setDefValue(e.target.value), props.onChange(e);
                  }}
                  classes={{
                    root: InitialBooleanValue
                      ? classes.mnavInputRoot
                      : classes.mnavInputRootToggle,
                    input: classes.mnavInputInput,
                  }}
                  inputProps={{ "aria-label": "search" }}
                />
              </div>
            </div>
            <div className={showEntity ? "" : classes.hideSearch}>
              <M_AddEntity edge="end" {...props} />
            </div>
            <div>
              <M_UserArea edge="end" {...props} />
            </div>
          </div>
        ) : (
          <></>
        )}
      </Toolbar>
      <A_SimpleDialog
        open={isMsgOpen}
        dialogContent=""
        closePopUp={handleMsgPopup}
        title="You have unsaved changes in the template. You can leave the page to discard the changes or cancel to continue editing and save all updates."
        dialogActions={getPublishActionItems()}
        onClose={handleMsgPopup}
        condition={true}
      />
    </>
  );
};

const M_NavBar = React.memo((props) => {
  const { user = null } = props;
  const classes = useStyles();

  return (
    <div>
      <A_AppBar
        style={{ color: "var(--color-primary-contrast)" }}
        className={classes.appBar}
        position="fixed"
        content={
          user === null ? (
            <BeforeLogin {...props} />
          ) : (
            <AfterLogin
              {...props}
              onChange={props.onChange}
              getCurrentPage={props}
            />
          )
        }
      />
    </div>
  );
});
M_NavBar.displayName = "M_NavBar";
M_NavBar.propTypes = {
  onChange: PropTypes.any,
  user: PropTypes.any,
  currentPage: PropTypes.any,
  condition: PropTypes.any,
};

AfterLogin.propTypes = {
  handleDrawer: PropTypes.any,
  onChange: PropTypes.any,
};

export default M_NavBar;
